import axios, { AxiosResponse } from "axios";
import { ArtDto } from "../Models/ArtDto";
import { SERVERURL } from "../Globals/Constants";
import { Profile } from "../Models/Profile";
import { Art } from "../Models/Art";

export const getAllArt = async () => {
  const { data } = await axios.get<Art[]>(`${SERVERURL}/api/art/getall`, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const getArt = async (user: Profile, artId: number) => {
  const { data } = await axios.get<Art>(`${SERVERURL}/api/art/get/${artId}`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const createArt = async (user: Profile, art: ArtDto): Promise<number> => {
  try {
    const formData = new FormData();

    formData.append("title", art.title);
    formData.append("description", art.description);
    formData.append("sellState", art.sellState);
    formData.append("type", art.type);

    if (art.mainImage) formData.append("mainImage", art.mainImage);
    if (art.files && art.files.length > 0) {
      art.files.forEach((file) => formData.append("files", file));
    }

    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/api/art/create`,
      formData,
      {
        headers: {

          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const addImageToArt = async (
  user: Profile,
  artId: number,
  files: File[]
): Promise<number> => {
  try {
    const formData = new FormData();

    if (!files || files.length === 0) {
      throw new Error("No image files provided");
    }

    files.forEach((file) => formData.append("files", file));

    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/api/art/${artId}/addImageToArt`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const removeArtImage = async (
  user: Profile,
  artId: number,
  fileId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/api/art/${artId}/removeImageFromArt/${fileId}`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const changeMainImage = async (
  user: Profile,
  artId: number,
  fileId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.put(
      `${SERVERURL}/api/art/${artId}/changeMainImage/${fileId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const updateArt = async (
  user: Profile,
  art: Partial<ArtDto>,
  artId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.put(
      `${SERVERURL}/api/art/update/${artId}`,
      art,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const deleteArt= async (user: Profile, artId: number) => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/api/art/remove/${artId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};
